import { FC } from 'react'
import { SocialMediaProps } from './interfaces'

const Instagram: FC<SocialMediaProps> = ({
  width = 20,
  height = 20,
  color = 'white',
}) => {
  const fillColor = {
    white: '#FFFFFF',
    'grey-500': '#75787B',
    black: '#212721',
  }
  const DEFAULT_COLOR = fillColor.white

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      version="1.1"
    >
      <g id="surface1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={fillColor[color] || DEFAULT_COLOR}
          d="M 5.773438 0.0859375 L 14.226562 0.0859375 C 17.402344 0.0859375 20 2.652344 20 5.785156 L 20 14.214844 C 20 17.351562 17.402344 19.914062 14.226562 19.914062 L 5.773438 19.914062 C 2.597656 19.914062 0 17.351562 0 14.214844 L 0 5.785156 C 0 2.652344 2.597656 0.0859375 5.773438 0.0859375 Z M 9.945312 4.648438 C 13.03125 4.648438 15.535156 7.152344 15.535156 10.234375 C 15.535156 13.320312 13.03125 15.824219 9.945312 15.824219 C 6.859375 15.824219 4.355469 13.320312 4.355469 10.234375 C 4.355469 7.152344 6.859375 4.648438 9.945312 4.648438 Z M 9.945312 6.535156 C 11.988281 6.535156 13.648438 8.191406 13.648438 10.234375 C 13.648438 12.28125 11.988281 13.9375 9.945312 13.9375 C 7.902344 13.9375 6.242188 12.28125 6.242188 10.234375 C 6.242188 8.191406 7.902344 6.535156 9.945312 6.535156 Z M 15.355469 3.871094 C 15.855469 3.871094 16.261719 4.277344 16.261719 4.777344 C 16.261719 5.28125 15.855469 5.6875 15.355469 5.6875 C 14.851562 5.6875 14.445312 5.28125 14.445312 4.777344 C 14.445312 4.277344 14.851562 3.871094 15.355469 3.871094 Z M 6.464844 1.707031 L 13.539062 1.707031 C 16.195312 1.707031 18.367188 3.867188 18.367188 6.507812 L 18.367188 13.617188 C 18.367188 16.261719 16.195312 18.421875 13.539062 18.421875 L 6.464844 18.421875 C 3.808594 18.421875 1.632812 16.261719 1.632812 13.617188 L 1.632812 6.507812 C 1.632812 3.867188 3.808594 1.707031 6.464844 1.707031 Z M 6.464844 1.707031 "
        />
      </g>
    </svg>
  )
}

export default Instagram
